.page-item {
    padding: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.page-item:hover {
    background-color: var(--off-white);
}

/* Wraps url or page title without squishing duration timestamp */
.page-item > :first-child {
    flex: 0 0 90%;
}

.page-title {
    color: var(--grey-lt);
    margin-top: 4px;
}

.page-info {
    display: flex;
    align-items: flex-start;
    gap: 8px;
}

.ma-url-label {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-top: 4px;
    color: var(--secondary-sidebar-hover-blue);
    font-size: 13px;
}

.page-item--ma-url {
    background-color: var(--blue-xlt);
}

.page-item--ma-url:hover {
    background-color: var(--blue-lt);
}
